import { Component, Prop } from "vue-property-decorator";
import { VueBase } from "../../Controls/VueBase";

@Component
export default class FiltreSelection extends VueBase {
	@Prop()
	public columns: any;
}



// WEBPACK FOOTER //
// ./src/components/requeteurModifieur/FiltreSelection/FiltreSelection.ts